import { Link } from '@inertiajs/react'
import AuthLayout from '@/layouts/AuthLayout'
import { AuthCard } from '@/components/AuthCard'
import { MailIcon } from 'lucide-react'

interface Props {
  email: string
  purpose?: 'login' | 'registration'
}

export default function MagicLinkSent ({ email, purpose = 'login' }: Props): React.ReactElement {
  const resendPath = purpose === 'registration' ? '/auth/registration/new' : '/auth/session/new'

  return (
    <AuthLayout>
      <AuthCard className='text-center'>
        <div className='w-14 h-14 rounded-full bg-accent flex items-center justify-center mx-auto mb-5 text-(--bp-accent)'>
          <MailIcon width={28} height={28} />
        </div>

        <div className='text-[20px] font-bold text-(--bp-ink) mb-[10px]'>
          メールを送信しました
        </div>

        <div className='text-[13px] text-muted-foreground leading-[1.7] mb-5'>
          <strong>{email}</strong> にリンクを送りました。
          <br />
          メールを確認してリンクをクリックしてください。
        </div>

        <div className='bg-(--bp-surface2) border border-(--bp-border) rounded-lg px-4 py-3.5 text-left text-xs text-(--bp-ink3) leading-[1.7]'>
          <div>⏱ リンクの有効期限は <strong className='text-muted-foreground'>15分</strong> です</div>
          <div>📁 メールが届かない場合は迷惑メールフォルダをご確認ください</div>
        </div>

        <div className='mt-5 text-xs text-(--bp-ink3)'>
          メールが届かない場合は{' '}
          <Link href={resendPath} className='text-(--bp-accent) font-medium no-underline'>
            再送する
          </Link>
        </div>
      </AuthCard>
    </AuthLayout>
  )
}
